import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCsfq2-jS0ojjm1UjjW3bMfbYlodUiNS34",
  authDomain: "health-records-valut.firebaseapp.com",
  projectId: "health-records-valut",
  storageBucket: "health-records-valut.firebasestorage.app",
  messagingSenderId: "514233452774",
  appId: "1:514233452774:web:4436541fecb018ddcf9327",
  measurementId: "G-0JPZZCEER3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
export const signInWithGoogle = () => signInWithPopup(auth, googleProvider);
